var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-builder',{attrs:{"fields":_vm.fields,"data":_vm.data},on:{"data":function($event){_vm.$emit('data', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }